<template>
  <div>
    <v-row class="ma-0 pa-0">
      <v-col
        class="px-0"
        cols="12"
        style="font-weight: 900;font-size: 32px;line-height: 44px;color: #576CB2;"
        :align="$store.state.isMobile ? 'center' : null"
      >
        Ebility Membership Beneﬁts
      </v-col>
      <v-col
        class="px-0"
        cols="12"
        style="font-weight: 500;font-size: 14px;line-height: 19px;color: #3D3D3D;"
        :align="$store.state.isMobile ? 'center' : null"
      >
        With Ebility, our goal is to make education for special children
        accessible, affordable by empowering educators like you.
      </v-col>
      <v-col
        class="px-0"
        cols="12"
        :style="$store.state.isMobile ? null : 'display: flex;'"
      >
        <div
          class="mr-8 mt-5 mt-md-0"
          style="display: flex;align-items: center;font-weight: 500;font-size: 17.9053px;line-height: 24px;color: #576CB2;"
        >
          <img
            height="30"
            width="32"
            style="margin-right: 10px;"
            src="@/assets/membership/grayCircledCheckMark.svg"
          />
          Free Perks
        </div>
        <div
          class="mr-8 mt-5 mt-md-0"
          style="display: flex;align-items: center;font-size: 17.9053px;line-height: 24px;color: #576CB2;"
        >
          <img
            height="30"
            width="32"
            style="margin-right: 10px;"
            src="@/assets/membership/grayCircledCheckMark.svg"
          />
          Exclusive Discounts
        </div>
        <div
          class="mr-8 mt-5 mt-md-0"
          style="display: flex;align-items: center;font-size: 17.9053px;line-height: 24px;color: #576CB2;"
        >
          <img
            height="30"
            width="32"
            style="margin-right: 10px;"
            src="@/assets/membership/grayCircledCheckMark.svg"
          />
          Unlimited Access
        </div>
        <!-- <div
          class="mr-8 mt-5 mt-md-0"
          style="display: flex;align-items: center;font-size: 17.9053px;line-height: 24px;color: #576CB2;"
        >
          <img
            height="30"
            width="32"
            style="margin-right: 10px;"
            src="@/assets/membership/grayCircledCheckMark.svg"
          />
          Membership Services
        </div> -->
        <!-- <div
          class="mr-8 mt-5 mt-md-0 ml-12 ml-md-0"
          style="margin-right: 40px; display: flex;align-items: center;font-size: 17.9053px;line-height: 24px;color: #576CB2;"
        >
          & many more
        </div> -->
      </v-col>

      <v-row
        class="my-7"
        :align="$store.state.isMobile ? 'center' : null"
        :justify="$store.state.isMobile ? 'center' : null"
      >
        <v-col cols="11" md="4" v-for="(item, index) in items" :key="index">
          <v-card
            style="border-radius: 27px!important;border: 2px solid #D3D3D3;"
            flat
          >
            <v-img
              height="212"
              width="100%"
              style="background: #F2F2F2;border-radius: 27px 27px 0px 0px;"
              :src="item.image"
            />
            <v-card-text class="px-12">
              <div
                align="center"
                style="font-weight: 800;font-size: 17.8306px;line-height: 24px;color: #576CB2;"
              >
                {{ item.heading }}
              </div>
              <div
                class="my-3"
                align="center"
                style="font-weight: 300;font-size: 15.072px;line-height: 21px;color: #000000;"
              >
                ({{ item.sub_heading }})
              </div>
              <!-- <v-divider
                  style="background: #D3D3D3;border: 1px solid #576CB2;"
              />
              <div
                  class="my-3"
                  align="center"
                  style="font-weight: 300;font-size: 15.072px;line-height: 21px;color: #000000;"
              >
                Original Price: Rs. 799/-
              </div> -->
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-container class="px-0">
        <v-col class="pa-0 my-9" cols="12">
          <v-divider style="border: 1px solid #B5B5B5;" />
        </v-col>
      </v-container>

      <v-col
        align="center"
        cols="12"
        style="font-weight: 900;font-size: 32px;line-height: 44px;text-align: center;color: #576CB2;"
      >
        Special Educators love using Eblity to learn and grow in their careers
      </v-col>
      <v-col
        align="center"
        cols="12"
        style="font-weight: 300;font-size: 17.7127px;line-height: 24px;color: #000000;"
      >
        Early bird pricing only valid for the first 100 members
      </v-col>
      <v-col cols="12" class="my-8" align="center">
        <v-btn
          class="px-10 px-md-16"
          depressed
          style="border-radius: 10px;font-weight: 800;font-size: 18.1871px;color: #FFFFFF;"
          height="56"
          color="#F2994A"
          @click="subscribe()"
        >
          Become a Member Today
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import authToken from "../../common/authToken";
  import store from "../../store";
  import { ROUTER_URL } from "../../constants/urls";
  import AmplitudeHelper from "../../amplitude";

  export default {
    name: "MembershipBenefits",
    props: ["plan"],
    components: {},
    data() {
      return {
        trainingWorkshop: require("@/assets/membership/trainingWorkshop.svg"),
        expertWebinar: require("@/assets/membership/expertWebinar.svg"),
        learningResource: require("@/assets/membership/learningResource.svg"),
        studentSuccess: require("@/assets/membership/studentSuccess.svg"),
        guidedMentorship: require("@/assets/membership/guidedMentorship.svg"),
        exclusiveCommunity: require("@/assets/membership/exclusiveCommunity.svg"),
        isFirstMembership: authToken.decodedToken().membership_validity
          ? false
          : true,
      };
    },
    created() {},
    computed: {
      items() {
        return [
          {
            heading: "Unlimited Training Workshops",
            sub_heading: "Watch live or on-demand",
            image: this.trainingWorkshop,
          },
          {
            heading: "Unlimited Expert Webinars",
            sub_heading: "Upskill yourself constantly",
            image: this.expertWebinar,
          },
          {
            heading: "Unlimited Learning Resources",
            sub_heading: "Focus on ADHD, ASD, SLD & more",
            image: this.learningResource,
          },
          {
            heading: "Student Success App",
            sub_heading: "Manage Students Better",
            image: this.studentSuccess,
          },
          {
            heading: "Guided Mentorship",
            sub_heading: "Learning Paths & Guidance",
            image: this.guidedMentorship,
          },
          {
            heading: "Exclusive Community",
            sub_heading: "Curated Community of Educators",
            image: this.exclusiveCommunity,
          },
        ];
      },
      membershipDetails: {
        get() {
          return this.$store.state.membership.selectedMembership;
        },
        set(value) {
          this.$store.dispatch("membership/updateSelectedMembership", value);
        },
      },
    },
    watch: {},
    methods: {
      subscribe() {
        if (authToken.decodedToken().is_member) {
          store.dispatch("snackBar/showToast", {
            message: "You already are a member",
            color: "S",
          });
        } else {
          // this.$store.state.payment.sessionSeriesId = null;
          // this.$store.state.sessionSeriesDetails.data = null;
          // this.$store.state.membership.isRenewMembership = false;
          // this.membershipDetails = plan;

          // this.$router.push({
          //   name: ROUTER_URL.publicSession.children.membershipCheckout.name,
          // });

          this.$store.state.payment.sessionSeriesId = null;
          this.$store.state.sessionSeriesDetails.data = null;
          this.$store.state.membership.isRenewMembership = false;
          this.membershipDetails = this.plan;

          var membershipType = this.isFirstMembership
            ? this.plan.price == 0
              ? "free"
              : "new"
            : "renewal";

          AmplitudeHelper.chooseMemebrshipEvent(
            "membership",
            membershipType,
            {}
          );

          this.$router.push({
            name: ROUTER_URL.publicSession.children.membershipCheckout.name,
          });
        }
      },
    },
    mounted() {},
  };
</script>
<style scoped></style>
